import axios from "@/libs/api.request";
export function getUser(params) {
    return axios.request({
        url: "UserInfo/getUserList",
        method: "post",
        data:params
    })
}
export function getUserInfo(params) {
    return axios.request({
        url: "UserInfo/getUserInfo",
        method: "get",
        params:params
    })
}

export function getSalerTreeNum(params) {
    return axios.request({
        url: "UserInfo/getSalerTreeNum",
        method: "get",
        params:params
    })
}
